<template>
  <div id="familyManagement">
    <h5 class="pf-sub-head mb-3">Search Families</h5>
    <v-layout wrap row class="mb-4">
      <v-flex sm3 class="pr-2">
        <v-text-field ref="searchField" append-icon="search" @keyup.enter="searchFamilies('family')" @click:append="searchFamilies('family')" v-model="query.family" label="Search by Family / PPN" hint="Type atleast 3 characters to search, PPN should be entered fully"></v-text-field>
      </v-flex>
      <v-flex sm3 class="pr-2">
        <v-select 
          class="filter_left"
          v-model="filterStatus" 
          label="Filter by status"
          :items="[...['All'], ...statusList].filter(x => x !== 'Rejected')" 
          @change="filterByStatus">
          <template v-slot:item="data">
            <template>
              <v-list-tile-content>
                <v-list-tile-title v-html="`${data.item} <small class='account-status-text'>  ${data.item === 'All' ? '' : '-'} ${(data.item === 'Active' || data.item === 'In Progress') ? '(Badge Avaliable)' : data.item === 'All' ? '' : '(Badge not Avaliable)'}</small>`"></v-list-tile-title> <!-- (total : 56, badge: 53) -->
              </v-list-tile-content>
            </template>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm3 class="pr-2">
        <v-select 
          class="filter_left"
          v-model="filterPlacementStatus" 
          label="Filter by Placement Status" 
          :items="[...['All'], ...placementList]"
          @change="filterByPlacementStatus">
           <template v-slot:item="data">
            <template>
              <v-list-tile-content>
                <v-list-tile-title v-html="`${data.item} <small>- (Total: ${data.item !== 'All' ? MyFamilies.filter(family => family.placement_status.status === data.item).length : MyFamilies.length}, Badge: ${ countArr[0] ? countArr[0][data.item] : ''})</small>`"></v-list-tile-title> <!-- (total : 56, badge: 53) -->
              </v-list-tile-content>
            </template>
          </template>
        </v-select>
      </v-flex>
      <v-flex sm3 class="pr-2">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search by Name"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="familyList"
        :search="search"
        no-data-text="No results, Search for your families"
        :pagination.sync="pagination" 
        class="pf-data-table"
        :key="familyListKey"
      >
        <template v-slot:items="props">
          <tr :class="{ 'pf-row-highlighted': props.item.agency && props.item.agency.length > 1 }" v-if="Agency.account.findIndex(item => item.account === props.item.id) > -1">
            <td width="300">
              <v-layout justify-left>
              {{ familyName(props.item) }}
              </v-layout>
              </td>
            <td>
              <v-layout justify-left>
                {{ props.item.nickname }}
              </v-layout>
            </td>
            <td>
              <v-layout justify-left>
                {{ props.item.human[0].user && props.item.human[0].user.username ? props.item.human[0].user.username : '' }}
              </v-layout>
            </td>
            <td width="100">
              <v-layout justify-center>
                {{ props.item.ppn }}
              </v-layout>
            </td>
            <td width="160">
              <v-layout justify-center>
                <v-select
                  :items="statusList"
                  height="30px"
                  :disabled="!Agency.is_super_admin && !session.getSession().adminUser && Agency.account[Agency.account.findIndex(item => item.account === props.item.id)].status === 'Suspended'"
                  :value="Agency.account[Agency.account.findIndex(item => item.account === props.item.id)].status"
                  @change="updateStatus(props.item, $event, 'status')"
                ></v-select>
              </v-layout>
            </td>
            <td width="120">
              <v-layout justify-center>
                {{ dateFormate(props.item.joined_date) }}
              </v-layout>
            </td>
             <td width="120">
              <v-layout justify-center>
                <v-menu
                v-model="waitingPicker[familyList.indexOf(props.item)]"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFormate(props.item.waiting_for)"
                    persistent-hint
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker color="#019d8c" :max="new Date().toISOString().substr(0, 10)" :value="props.item.waiting_for ? props.item.waiting_for.substr(0, 10) : ''" @input="changeWaitingFor($event, props.item)"></v-date-picker>
              </v-menu>
              </v-layout>
            </td>
            <td v-if="((props.item.placement_status && props.item.placement_status.status === 'Waiting') || (props.item.agency && props.item.agency.length === 1) || props.item.placement_status.agency === Agency.id) && Agency.account[Agency.account.findIndex(item => item.account === props.item.id)].status === 'Active'">
              <v-layout justify-center>
              <v-select
                v-model="props.item.placement_status.status"
                :items="placementstatus"
                :item-text="'text'"
                :item-value="'value'"
                height="30px"
                @change="updateStatus(props.item, $event, 'placement_status')"
              ></v-select>
              </v-layout>
            </td>
            <td v-else>
              <v-layout justify-center class="pr-3">
                {{ props.item.placement_status.status }}
              </v-layout>
            </td>
            <td class="text-center">
              <v-btn icon small class="mr-0 ml-0" v-if="Agency.account[Agency.account.findIndex(item => item.account === props.item.id)].status === 'Active' && props.item.avatar !== ''">
                <v-icon size="20" class="pf-text-teal">thumb_up</v-icon>
              </v-btn>
              <v-btn v-else icon small class="mr-0 ml-0">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                <v-icon size="22" class="pf-icon-delete" v-on="on">thumb_down</v-icon>
                </template>
                  <span v-if="Agency.account[Agency.account.findIndex(item => item.account === props.item.id)].status !== 'Active'">Not Active</span>
                  <span v-if="Agency.account[Agency.account.findIndex(item => item.account === props.item.id)].status === 'Active' && props.item.avatar === ''">No Avtar</span>
                </v-tooltip>
              </v-btn>
            </td>
            <td align="right" style="white-space:nowrap;">
              <v-btn icon small class="mr-0 ml-0">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                <v-icon size="22" class="pf-text-teal" v-on="on">info</v-icon>
                </template>
                  <span>Linked to {{props.item.agency.length}} {{ props.item.agency.length === 1 ? 'Agency' : 'Agencies' }}</span>
                  <br>
                  <span v-html="getAgencyNames(props.item.agency)"></span>
                </v-tooltip>
              </v-btn>
              <v-menu offset-y >
                <template v-slot:activator="{ on }">
                <v-btn icon small class="mr-0 ml-0" v-on="on">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                  <v-icon size="22" color="grey darken-2" v-on="on">apps</v-icon>
                  </template>
                    <span>More</span>
                  </v-tooltip>
                </v-btn>
                </template>
                <v-list>
                  <v-list-tile v-if="!session.getSession().adminUser" @click="logonFamily(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">call_made</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                     Dashboard
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="getHistory(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">history</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      History
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile :href="`${config.host}view-our-families/#/profile/${props.item.id}`" target="_blank">
                    <v-list-tile-action>
                      <v-btn icon class="ma-0">
                          <v-icon size="22" color="grey darken-2">person</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Profile
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile :target="props.item.nickname ? '_blank' : ''" :href="(props.item.nickname ? config.WPParams.host + 'profile/' + props.item.nickname : 'javascript:void(0)')">
                    <v-list-tile-action>
                      <v-btn icon class="ma-0">
                          <v-icon size="22" color="grey darken-2">remove_red_eye</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      View
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="deleteRequest(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" class="pf-icon-delete">delete_outline</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                     Remove
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <template>
      <div class="text-xs-center">
        <v-dialog
          v-model="isHistoryActive"
          width="700"
        >
          <v-card>
            <v-card-title
              class="pf-bg-teal pf-pos-relative headline white--text"
            >
              History &nbsp; <small>-&nbsp; {{ (historyUsername ? historyUsername : 'Unknown') }}</small>
              <v-btn class="pf-icon-top-right" icon dark @click="isHistoryActive = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <app-history :data="historyList"></app-history>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="white"
                flat
                @click="isHistoryActive = false"
                class="pf-bg-pink"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
<script>
/* global session config store moment */
import { getOne, getCollection, update, remove, create, formatDate, requestExternal, request } from '../helpers/helpers';
import swal from 'sweetalert2';
import appHistory from './History/list';
export default {
  components: { appHistory },
  data: () => ({
    entity: 'Agency',
    waitingPicker: [],
    config: config,
    search: '',
    filterStatus: 'All',
    filterPlacementStatus: 'All',
    familyList: [],
    searchResults: [],
    query: {
      family: ''
    },
    historySearch: '',
    historyUsername: '',
    historyList: [],
    historyHeaders: [
      { text: '#', value: 'id', align: 'left' },
      { text: 'Area', value: 'entity', align: 'left' },
      { text: 'Updated By', value: 'updatedBy' },
      { text: 'Date & Time', value: 'createdAt' }
    ],
    isHistoryActive: false,
    max8chars: v => v.length <= 8 || 'Input too long!',
    statusList: ['Active', 'Approved', 'Inactive', 'In Progress', 'Pending', 'Rejected', 'Suspended'],
    placementList: ['Waiting', 'Matched', 'Placed'],
    headers: [
      { text: 'Family', value: 'name', align: 'left' },
      { text: 'Nickname', value: 'nickname', align: 'left' },
      { text: 'Username', value: 'nickname', align: 'left' },
      { text: 'PPN', value: 'ppn', align: 'center', width: '100px' },
      { text: 'Status', value: 'status', align: 'center', width: '150px' },
      { text: 'Join Date', value: 'createdAt', align: 'center', width: '120px' },
      { text: 'Waiting Since', value: 'waiting_for', align: 'left', width: '120px' },
      { text: 'Placement', value: 'placement_status.status', align: 'center', width: '100px' },
      { text: 'Badge', sortable: false, align: 'center' },
      { text: '', sortable: false, align: 'right', width: '120px' },
    ],
    placementstatus: [
      {
        value: 'Waiting',
        text: 'Waiting'
      },
      {
        value: 'Matched',
        text: 'Matched'
      },
      {
        value: 'Placed',
        text: 'Placed'
      }
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    historyPagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    countArr: [],
    familyListKey: `list-key-${new Date().getTime()}`
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    },
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
    MyFamilies: {
      set (value) {
        store.commit('setMyFamilies', value);
      },
      get () {
        return store.state.MyFamilies;
      }
    },
    JSONData: {
      get () {
        return store.state.JSONData;
      },
      set (value) {
        store.commit('setJSONData', value);
      }
    }
  },
  watch: {
    MyFamilies (value) {
      this.MyFamilies = value;
      this.familyList = this.MyFamilies;
      this.query.family = '';
    }
  },
  async created () {
    this.initialize();
    this.initializeAgencyList();
    await this.setFamilyCountByStatus();
  },

  methods: {
    async setFamilyCountByStatus () {
      if (!Object.keys(this.JSONData).length) {
        /* if (config.host.indexOf('localhost') > -1) {
          this.JSONData = require('../store/families.json');
        } else { */
        let JSONUrl = config.uploadPath + 'agency/' + this.Agency.id + '/BadgeProfile/families.json?' + Math.random();
        let response = await requestExternal(JSONUrl, 'GET');
        this.JSONData = response.data;
        /* } */
        if (!Object.keys(this.JSONData).length) {
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Not able to fetch the family counts'
          };
        }
      }
      let Waiting = await this.JSONData.profiles.filter(x => x.placement_status && x.placement_status.status === 'Waiting');
      Waiting = Waiting === undefined ? 0 : Waiting.length;
      let Matched = await this.JSONData.profiles.filter(x => x.placement_status && x.placement_status.status === 'Matched');
      Matched = Matched === undefined ? 0 : Matched.length;
      let Placed = await this.JSONData.profiles.filter(x => x.placement_status && x.placement_status.status === 'Placed');
      Placed = Placed === undefined ? 0 : Placed.length;
      this.countArr.push({ 'Waiting': Waiting, 'Matched': Matched, 'Placed': Placed, 'All': Waiting + Matched + Placed });
    },
    dateFormate (date) {
      if (!date) return '';
      let dateString = date.substr(0, 10);
      const [year, month, day] = dateString.split('-');
      return `${month}/${day}/${year}`;
    },
    async changeWaitingFor (e, item) {
      this.waitingPicker = [];
      this.waitingPicker.push(false);
      let itemIndex = this.familyList.indexOf(item);
      this.familyList[itemIndex].waiting_for = new Date(e).toISOString();
      let updateItem = JSON.parse(JSON.stringify(item));
      updateItem.updated_from = 'default';
      this.unChangedList = JSON.parse(JSON.stringify(this.familyList));
      let updateId = this.familyList[itemIndex]._id || this.familyList[itemIndex].id;

      /* Update the user ids */
      if (updateItem.human && updateItem.human.length) {
        updateItem.human = updateItem.human.map(x => {
          if (x && x.user && x.user._id) {
            x.user = x.user._id;
          }
          return x;
        });
      }
      
      let { error, data, status } = await update('Account', updateItem, updateId);
      if (error) {
        console.log('error', error);
        swal.fire({
          type: 'error',
          title: 'Failed to update data',
          showConfirmButton: true,
          timer: 2500,
        });
      } else {
        swal.fire({
          type: 'success',
          title: 'Waiting Since saved successfully',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    },
    async initializeAgencyList () {
      if (!this.AgencyList.length) {
        let where = { _id: { $ne: this.Agency.id }, is_admin: false };
        let attributes = 'name,nickname,email,createdAt,_id,mapping_id';
        let populate = [{ path: 'human', select: '_id user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    getAgencyNames (agencyList) {
      if (agencyList.length) {
        let agencyId = agencyList.map(agency => agency.agency);
        let list = this.AgencyList.filter(agency => agencyId.indexOf(agency.id) !== -1);
        list.push({ name: this.Agency.name });
        let names = list.map(agency => agency.name);
        return names.join(', <br>');
      }
    },
    async initialize () {
      if (!this.MyFamilies.length) {
        let populate = [{ 'path': 'human', 'populate': { 'path': 'user', 'select': 'username' }}, 'contactInfo.country', 'contactInfo.state'];
        let where = { 'agency.agency': this.Agency.id, 'agency.status': { '$in': ['Pending', 'Active', 'Inactive', 'In Progress', 'Approved', 'Unconfirmed', 'Suspended'] }};
        let sort = { 'agency.updatedAt': -1 };
        let { error, data } = await getCollection('Account', true, 0, populate, where, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.MyFamilies = data;
          }
        }
      }
      this.familyList = this.MyFamilies;
    },
    filterByPlacementStatus () {
      if (this.filterPlacementStatus === 'All') {
        this.familyList = this.query.family && this.query.family !== '' ? this.searchResults : this.MyFamilies;
      } else if (this.query.family && this.query.family !== '') {
        this.familyList = this.searchResults.filter(account => account.placement_status.status === this.filterPlacementStatus);
      } else {
        this.familyList = this.MyFamilies.filter(account => account.placement_status.status === this.filterPlacementStatus);
      }
      // filter by the status as well
      if (this.filterStatus !== 'All') {
        this.familyList = this.familyList.filter(account => account.agency.find(agency => agency.status === this.filterStatus && agency.agency === this.Agency.id));
      }
    },
    filterByStatus () {
      if (this.filterStatus === 'All') {
        this.familyList = this.query.family && this.query.family !== '' ? this.searchResults : this.MyFamilies;
      } else if (this.query.family && this.query.family !== '') {
        this.familyList = this.searchResults.filter(account => account.agency.find(agency => agency.status === this.filterStatus && agency.agency === this.Agency.id));
      } else {
        this.familyList = this.MyFamilies.filter(account => account.agency.find(agency => agency.status === this.filterStatus && agency.agency === this.Agency.id));
      }
      // filter by the placement status as well
      if (this.filterPlacementStatus !== 'All') {
        this.familyList = this.familyList.filter(account => account.placement_status && account.placement_status.status === this.filterPlacementStatus);
      }
    },
    familyName (item) {
      let name = '';
      item.human.forEach((human, k) => {
        let parentName = human.first_name + (human.last_name ? (' ' + human.last_name) : '') + (k === 0 && item.account_type === 'Couple' && item.human.length > 1 ? ' / ' : '');
        name += parentName;
      });
      return name;
    },
    formatDate (dateString) {
      if (dateString) {
        return formatDate(dateString, 'MM/DD/YYYY');
      }
    },
    // @vuese
    // Used to search for families on entering nickname, PPN or the status
    // @arg The type of search - family or status
    async searchFamilies (searchType) {
      this.familyList = [];
      if (this.query.family === '' && this.query.family.length === 0) {
        this.familyList = this.MyFamilies;
        // Reset the status filter
        this.filterStatus = 'All';
        this.filterPlacementStatus = 'All';
        return;
      }
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if ((this.query.family && this.query.family.length && this.query.family.length > 2)) {
        let where = { 'agency.agency': this.Agency.id, 'agency.status': { '$in': ['Pending', 'Active', 'Inactive', 'In Progress', 'Approved', 'Unconfirmed', 'Suspended'] }};
        if (this.query.family && this.query.family.length > 2) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'human.first_name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'human.last_name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        if (this.query.family && !isNaN(this.query.family)) {
          where.$or.push({
            'profile_number': this.query.family
          });
        }
        let populate = [{ 'path': 'human', 'populate': { 'path': 'user', 'select': 'username' }}, 'contactInfo.country', 'contactInfo.state'];
        let sort = { 'agency.updatedAt': -1 };
        let { error, data } = await getCollection('Account', true, 0, populate, where, null, null, sort);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          // Reset the status filter
          this.filterStatus = 'All';
          this.filterPlacementStatus = 'All';
          if (data.length > 0) {
            this.familyList = data;
            this.searchResults = data;
          }
        }
      }
    },
    async updateStatus (item, newStatus, type) {
      if (!item || !item._id || !newStatus || !type) {
        return;
      }
      try {
        const payload = {
          agency: this.Agency._id,
          account: item._id,
        };
        payload[type] = newStatus;
        window.getApp.$emit('AppProgress', true);
        let { error, data } = await request('Agency/StatusUpdate', 'POST', payload);
        if (error) {
          console.log('error', error);
        } else {
          swal.fire({
            type: 'success',
            title: 'Success',
            text: `The family status was successfully changed into '${newStatus}'`,
            showConfirmButton: true
          });
        }
        window.getApp.$emit('AppProgress', false);
      } catch (e) {
        console.log('error', e);
        window.getApp.$emit('AppProgress', false);
        swal.fire({
          type: 'error',
          title: 'Error',
          text: 'Unable to update the status, please try again later.',
          showConfirmButton: true
        });
      }
    },
    // eslint-disable-next-line
    async saveRequest (entity, item, newStatus = null, requestFrom = null) {
      try {
        if ((newStatus === 'Active' || requestFrom === 'placementStatus') && (item.avatar === '' || item.avatar === null)) {
          this.familyListKey = `list-key-${new Date().getTime()}`;
          swal.fire({
            type: 'error',
            title: 'Error',
            text: 'Please upload an avatar image to the family before changing the status',
            showConfirmButton: true
          });
          return;
        } else {
          this.Agency.account[this.Agency.account.findIndex(x => x.account === item.id)].status = newStatus;
        }
        let updateItem;
        let updateId;
        if (entity === 'Agency') {
          updateId = this.Agency._id || this.Agency.id;
          updateItem = JSON.parse(JSON.stringify(this.Agency));
          if (!updateItem._id) {
            updateItem._id = this.Agency._id || this.Agency.id;
          }
          updateItem.updated_from = 'badge';
        } else if (entity === 'Account') {
          item.placement_status.agency = this.Agency.id;
          updateItem = JSON.parse(JSON.stringify(item));
          updateId = item._id || item.id;
          updateItem.updated_from = 'default';
          updateItem.placement_status = {
            status: updateItem.placement_status.status,
            agency: this.Agency.id
          };
          if (!updateItem._id) {
            updateItem._id = item._id || item.id;
          }
          if (requestFrom) {
            updateItem.updated_from = requestFrom;
          } else {
            updateItem.updated_from = 'default';
          }
          /* Update the user ids */
          if (updateItem.human && updateItem.human.length) {
            updateItem.human = updateItem.human.map(x => {
              if (x && x.user && x.user._id) {
                x.user = x.user._id;
              }
              return x;
            });
          }
        }
        if (!updateId || !updateItem._id) {
          swal.fire({
            type: 'error',
            title: 'Error',
            text: 'Unable to update the details, please refresh the page and try again.',
            showConfirmButton: true
          });
          return;
        }
        window.getApp.$emit('AppProgress', true);
        let { error, data, status } = await update(entity, updateItem, updateId);
        if (error) {
          console.log('error', error);
        } else {
          this[entity] = data;
          if (entity === 'Agency') {
            // Remove the rejected families
            this.familyList = this.familyList.filter(account => account.agency.find(agency => agency.status !== 'Rejected'));
            let accountObj = this.Agency.account.find(account => account.account === item.id);
            let TimelineObj = {
              text: `The agency '${this.Agency.name}' changed your status to '${accountObj.status}'`,
              title: 'Status Changed',
              account: item.id
            };
            // Update the Account if Active or Approved - Zoho sync
            let activeIndex = ['Active', 'Approved'].indexOf(newStatus);
            if (newStatus) {
              let itemIndex = this.MyFamilies.findIndex(x => x.id === item.id);
              let accountPayload = JSON.parse(JSON.stringify(item));
              if (accountPayload.agency && accountPayload.agency.length) {
                let agencyIndex = accountPayload.agency.findIndex(agency => agency.agency === this.Agency.id);
                if (agencyIndex > -1) {
                  accountPayload.agency[agencyIndex].status = newStatus;
                }
              }
              if (!accountPayload.default_agency) {
                accountPayload.default_agency = this.Agency.id;
              }
              accountPayload.updated_from = activeIndex > -1 ? 'statusChange' : 'statusInactive';
              accountPayload.newStatus = newStatus;

              /* Update the user ids */
              if (accountPayload.human && accountPayload.human.length) {
                accountPayload.human = accountPayload.human.map(x => {
                  if (x && x.user && x.user._id) {
                    x.user = x.user._id;
                  }
                  return x;
                });
              }
              window.getApp.$emit('AppProgress', true);
              let { error: accountError, data: accountData, status: accountStatus } = await update('Account', accountPayload, item._id || item.id);
              if (accountError) {
                console.log('error', accountError);
              } else {
                /* Update the email with state */
                if (this.MyFamilies[itemIndex] && accountData.contactInfo) {
                  this.MyFamilies[itemIndex].contactInfo = accountData.contactInfo;
                }
                this.MyFamilies = this.MyFamilies;
                this.familyList = this.MyFamilies;
              }
            }
            // Create the timeline
            window.getApp.$emit('AppProgress', true);
            let { error: TimelineError, data: timelineData } = await create('Timeline', TimelineObj);
            if (TimelineError) {
              console.log('error', TimelineError);
            }
          }
          window.getApp.$emit('AppProgress', false);
          swal.fire({
            type: 'success',
            title: 'Details saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
            }
          });
        }
        window.getApp.$emit('AppProgress', false);
      } catch (e) {
        console.log('error', e);
        window.getApp.$emit('AppProgress', false);
        swal.fire({
          type: 'error',
          title: 'Error',
          text: 'Unable to update the details, please refresh the page and try again.',
          showConfirmButton: true
        });
      }
    },
    async handleRemoveAgency (item, unsubscribe = false) {
      const familyIndex = this.MyFamilies.findIndex(row => row.id === item.id);
      this.MyFamilies.splice(familyIndex, 1);
      const agencyIndex = this.Agency.account.findIndex(row => row.account === item.id);
      this.Agency.account.splice(agencyIndex, 1);
      this.Agency.updated_from = 'badge';
      const payload = { ...this.Agency };
      if (unsubscribe) {
        payload.isUnsubscribe = unsubscribe;
        payload.unSubscribeAccount = item._id || item.id;
      }
      let { error, data, status } = await update(this.entity, payload, this.Agency._id || this.Agency.id);
      if (error) {
        console.log('error', error);
      } else {
        let TimelineObj = {
          text: `The agency '${this.Agency.name}' removed you from their family list`,
          title: 'Profile Removed',
          account: item.id
        };
        let { TimelineError, timelineData } = await create('Timeline', TimelineObj);
        if (TimelineError) {
          console.log('error', TimelineError);
        }
        swal.fire(
          'Deleted!',
          'The family "' + item.name + '" has been removed from the list.',
          'success'
        );
      }
    },
    async deleteRequest (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {

            // Check if an active payment subscriptionn exists if not default agency
            if (item.default_agency !== this.Agency.id) {
              // Request to get the active subscription
              let { error: subscriptionError, data: subscriptionData } = await getCollection('PaymentSubscription', true, 10, '', { 'account': item.id, 'status': 'Subscribed', agency: this.Agency.id });
              if (subscriptionError) {
                console.log('subscriptionError', subscriptionError);
              } else if (subscriptionData.length) {
                swal.fire({
                  type: 'warning',
                  title: 'Unsubscribe',
                  text: 'This family has an active subscription with you. This will unsubscribe before removing the family.',
                  showCancelButton: true,
                  confirmButtonText: 'Unsubscribe',
                  cancelButtonText: 'Cancel',
                }).then(async (confirm) => {
                  if (confirm.value) {
                    // Unsubscribe the active subscription with an additional parameter
                    await this.handleRemoveAgency(item, true);
                  }
                });
              } else {
                await this.handleRemoveAgency(item);
              }
            } else {
              await this.handleRemoveAgency(item);
            }
          })();
        }
      });
    },
    async logonFamily (family) {
      let sessionData;
      let { error, data } = await getOne('User', family.human[0].user.id);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Something went wrong, please try again.'
        };
      } else {
        delete data.access;
        sessionData = { ...session.getSession() };
        sessionData.adminUser = session.getSession().user;
        sessionData.user = data;
        session.setSession(sessionData, false);
        window.location = config.client;
      }
    },
    async getHistory (family) {
      let humanIds = Array.from(family.human, x => x.id);
      let sort = { 'createdAt': -1 };
      let where = { '$or': [{ 'entity': 'Account', 'document_id': family.id }, { 'entity': 'Human', 'document_id': { '$in': humanIds }}], 'updatedBy': { '$exists': true }};
      let populate = { path: 'updatedBy', select: 'entity updatedBy createdAt', populate: { path: 'human', select: 'first_name last_name' }};
      
      if (family.human && family.human.length) {
        where['$or'].push({ 'entity': 'User', 'document_id': family.human[0].user.id });
      }
      let { error, data } = await getCollection('History', true, 10, populate, where, null, null, sort);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Something went wrong, please try again.'
        };
      } else {
        this.historyList = data;
        this.isHistoryActive = true;
        this.historyUsername = family.human[0].first_name + ' ' + family.human[0].last_name;
      }
    }
  }
};
</script>
<style scoped>
.text-right {
  text-align: right !important;
}

#familyManagement >>> .v-select__selection {
    width: 100%;
    justify-content: center;
    padding-left: 20px;
}

#familyManagement >>> .filter_left .v-select__selection {
  justify-content: start !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/FamilyManagement.vue